module.exports = __webpack_public_path__ + "img/ticket_hover_4c355ea.webp";